import * as React from 'react';
import { observer } from 'mobx-react';
import { getButtonOptions, GooglePaySDKType } from '../utils/googlepay-utils';
import { responsiveHelper } from '../../Shared/helpers/responsive-helper';

@observer
export class GooglePayButton extends React.Component<{ onClick: () => void; client: GooglePaySDKType }, {}> {
	refNode: HTMLDivElement;

	componentDidMount() {
		if (this.refNode && this.props.client) {
			const options = getButtonOptions();
			options.onClick = this.props.onClick;
			const button = this.props.client.createButton(options);
			this.refNode.appendChild(button);
		}
	}

	render() {
		return (
			<div
				ref={this.saveRef}
				style={{
					height: 45,
					...(responsiveHelper.isXs ? { width: '100%' } : { width: 260 }),
				}}
				data-pp-at-target="googlePay-button-container"
			/>
		);
	}

	private saveRef = (node: HTMLDivElement) => (this.refNode = node);
}
